var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.loading && !_vm.disableProgressIndicator)?_c('PageProgress'):_c('executions-log-table',{attrs:{"rowClick":_vm.goToLog,"rows":_vm.executionRows}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }